
const lib = "/assets/portfolio/lib.png";
const trf = "/assets/portfolio/trf.png";
const rme = "/assets/portfolio/rme.png";
const dcc = "/assets/portfolio/dcc.png";
const loko = "/assets/portfolio/loko.png";
const ds1 = "/assets/projects/dst1.png";
const ds2 = "/assets/projects/dst2.png";
const ds3 = "/assets/projects/dst2.png";
const dolr1 = "/assets/projects/dolr1.png";
const dolr2 = "/assets/projects/dolr2.png";
const dolr3 = "/assets/projects/dolr3.png";
const iv1 = "/assets/projects/iv1.png";
const iv2 = "/assets/projects/iv2.png";
export const projects2 = [
  {
    id: 11,
    name: "Lokotech",
    slug: "lokotech",
    description: "Crypto Mining & Hardware",
    tags: ["Design", "Crypto", "Blockchain"],
    image: loko,
  },
  {
    id: 2,
    name: "The Real Flow",
    slug: "the-real-flow",
    description: "Global music distribution",
    type: "",
    tags: ["Streaming", "Blockchain"],
    image: trf,
  },
  {
    id: 3,
    name: "Digital Command Center",
    slug: "digital-command-center",
    description: "Project management SaaS",
    type: "",
    tags: ["SaaS", "CMS"],
    image: dcc,
  },
  {
    id: 5,
    name: "RepresentingME",
    slug: "representing-me",
    description: "Political media platform",
    type: "",
    tags: ["Web3"],
    image: rme,
  },
  {
    id: 6,
    name: "Librium Tech",
    slug: "librium-tech",
    description: "Crypto mining & investment",
    type: "",
    tags: ["Crypto", "Blockchain"],
    image: lib,
  },
  {
    id: 7,
    name: "Diverse Services",
    slug: "diverse-services",
    description: "Financial and business",
    type: 1,
    tags: ["Finance", "AI"],
    image: ds1,
  },
  {
    id: 8,
    name: "DOLR Coin",
    slug: "dolr-coin",
    description: "Blockchain-based Currency",
    type: 2,
    tags: ["Blockchain", "Finance"],
    image: dolr1,
  },
  {
    id: 9,
    name: "iVipp",
    slug: "ivipp",
    description: "Lifestyle Management & VIP Service",
    type: 2,
    tags: ["CRM", "AI"],
    image: iv1,
  },
];

export const projects = [
  {
    id: 2,
    name: "The Real Flow",
    slug: "the-real-flow",
    description: "Global music distribution",
    type: 1,
    tags: ["Streaming", "Blockchain"],
    images: [trf, trf, trf],
    details: {
      overview:
        "The Real Flow revolutionizes music distribution by providing artists with a decentralized platform to release unlimited music tracks across major streaming services. With blockchain integration, artists maintain ownership and transparency over their earnings.",
      features: [
        "Unlimited Music Releases",
        "Artist Ownership via Blockchain",
        "Web 3.0 Integration for Transparency",
        "Global Distribution to 150+ Platforms",
        "Streaming Analytics for Performance Insights",
        "Royalty Tracking and Payouts",
        "NFT Integration for Exclusive Content",
        "Artist Collaboration Tools",
      ],
      industry: "Music & Streaming",
      tech_stack: ["Next.js", "Solidity", "Ethereum", "AWS", "IPFS"],
      problem_solved:
        "Empowers independent artists with direct, transparent, and global music distribution.",
      key_metrics: [
        { title: "Songs Distributed", detail: "500K+ tracks" },
        { title: "Streaming Platforms", detail: "150+ services" },
        { title: "Artist Earnings", detail: "$10M+ revenue paid out" },
      ],
      link: "https://therealflow.com/",
    },
  },
  {
    id: 3,
    name: "Digital Command Center",
    slug: "digital-command-center",
    description: "Project management SaaS",
    type: 1,
    tags: ["SaaS", "CMS"],
    images: [dcc, dcc, dcc],
    details: {
      overview:
        "Digital Command Center is a robust SaaS solution that enables enterprises to manage projects, automate tasks, and collaborate seamlessly. It combines CMS tools with advanced project management features to optimize workflows and boost productivity.",
      features: [
        "Project Management Dashboard",
        "CMS Tools for Content Organization",
        "Task Automation for Efficiency",
        "Team Collaboration Tools",
        "Customizable Workflows",
        "Real-Time Notifications",
        "Integration with Third-Party Tools",
        "Analytics for Performance Tracking",
      ],
      industry: "Enterprise SaaS",
      tech_stack: ["Laravel", "React", "PostgreSQL", "Redis", "Docker"],
      problem_solved:
        "Streamlines enterprise project workflows with automation and collaboration tools.",
      key_metrics: [
        { title: "Projects Managed", detail: "1M+ projects" },
        { title: "Teams Using", detail: "50K+ companies" },
        { title: "Tasks Automated", detail: "500K+ daily tasks" },
      ],
      link: "https://digitalcommandcenter.io/",
    },
  },
  {
    id: 5,
    name: "RepresentingME",
    slug: "representing-me",
    description: "Political media platform",
    type: 1,
    tags: ["Web3"],
    images: [rme, rme, rme],
    details: {
      overview:
        "RepresentingME.com is a groundbreaking platform where voters can engage directly with elected officials and candidates. It promotes transparency by allowing users to provide feedback on political positions and decisions.",
      features: [
        "Political Platform for Engagement",
        "Voter Feedback System",
        "Candidate Transparency Tools",
        "Elected Official Profiles",
        "Media Credibility Verification",
        "Blockchain for Data Integrity",
        "IPFS for Decentralized Storage",
        "Real-Time Notifications",
      ],
      industry: "Civic Engagement",
      tech_stack: ["React", "Blockchain", "IPFS", "Node.js", "MongoDB"],
      problem_solved:
        "Increases political transparency and voter engagement through direct communication and feedback.",
      key_metrics: [
        { title: "Registered Users", detail: "500K+ voters" },
        { title: "Politicians Joined", detail: "1K+ elected officials" },
        { title: "Votes Cast", detail: "10M+ feedback votes" },
      ],
      link: "https://representingme.com/",
    },
  },
  {
    id: 6,
    name: "Librium Tech",
    slug: "librium-tech",
    description: "Crypto mining & investment",
    type: 1,
    tags: ["Crypto", "Blockchain"],
    images: [lib, lib, lib],
    details: {
      overview:
        "Librium Tech introduces a unique tokenomics model that combines perpetual crypto mining investments with increasing mining rewards. It offers holders multiple streams of passive income and ensures growing token value through innovative mining strategies.",
      features: [
        "Perpetual Crypto Mining",
        "Increasing Mining Rewards",
        "Passive Income Streams",
        "Tokenomics Innovation",
        "Investment Growth Tools",
        "Blockchain Transparency",
        "Staking Options",
        "Reward Distribution System",
      ],
      industry: "Blockchain & Crypto",
      tech_stack: ["Solidity", "Ethereum", "React", "Node.js", "IPFS"],
      problem_solved:
        "Provides a sustainable and innovative solution for passive income through crypto mining and tokenomics.",
      key_metrics: [
        { title: "Total Mining Rewards", detail: "$5M+ distributed" },
        { title: "Active Investors", detail: "10K+ holders" },
        { title: "Token Value Growth", detail: "200%+ annual growth" },
      ],
      link: "https://librium.tech/",
    },
  },
  {
    id: 7,
    name: "Diverse Services",
    slug: "diverse-services",
    description: "Financial and business",
    type: 2,
    tags: ["Finance", "AI"],
    images: [ds1, ds2, ds3],
    details: {
      overview:
        "Diverse Services provides expert financial and business solutions, including tax preparation, bookkeeping, printing, and notary services. With a commitment to accuracy, accessibility, and long-term client relationships, the company serves individuals and businesses across all 50 states.",
      features: [
        "Professional Tax Preparation",
        "Comprehensive Tax Management",
        "Accurate and Timely Bookkeeping",
        "Printing Services for Business Needs",
        "Certified Notary Services",
        "Dedicated Primary Contact for Clients",
        "Multi-Channel Support for Assistance",
        "100% Accuracy Guarantee on Financial Services",
      ],
      industry: "Finance & Business Services",
      tech_stack: [
        "QuickBooks",
        "Xero",
        "Stripe API",
        "Custom CRM",
        "Cloud-Based Tax Software",
      ],
      problem_solved:
        "Eliminates financial management complexities and ensures businesses and individuals receive reliable and professional financial support.",
      key_metrics: [
        { title: "Clients Served", detail: "10K+ satisfied customers" },
        { title: "Years of Service", detail: "11+ years of trusted expertise" },
        { title: "Support Channels", detail: "24/7 multi-channel assistance" },
      ],
      link: "https://trusting-hellman.195-250-25-147.plesk.page/",
    },
  },
  {
    id: 8,
    name: "DOLR Coin",
    slug: "dolr-coin",
    description: "Blockchain-based Currency",
    type: 1,
    tags: ["Blockchain", "Finance"],
    images: [dolr1, dolr2, dolr3],
    details: {
      overview:
        "DOLR Coin is a collateralized stablecoin built on proprietary blockchain technology. It provides a secure digital asset backed by real-time gold value, ensuring stability, transparency, and trustworthiness. The DOLR platform enables seamless transactions through web and mobile applications, making it a global currency alternative.",
      features: [
        "Gold-backed Stablecoin for Security and Stability",
        "Proprietary Blockchain Technology",
        "Real-Time Gold Price Pegging",
        "Decentralized Multi-Node Network",
        "Transparent and Consensus-Based Transactions",
        "Worldwide Accessibility via Web and Mobile",
        "Multi-Billion Dollar Gold Bond Security",
        "Instant Node Rewards and Incentives",
      ],
      industry: "Financial Services & Blockchain",
      tech_stack: [
        "Blockchain",
        "Node.js",
        "Distributed Ledger",
        "Smart Contracts",
      ],
      problem_solved:
        "Bridges the gap between traditional fiat currency and digital assets by offering a gold-backed, transparent, and decentralized stablecoin.",
      key_metrics: [
        { title: "Total Supply", detail: "100M+ DOLR Coins" },
        {
          title: "Gold Reserves",
          detail: "Multi-billion dollar gold-backed security",
        },
        { title: "Node Network", detail: "10K+ active nodes worldwide" },
      ],
      link: "https://dolrcoin.com/",
    },
  },
  {
    id: 9,
    name: "iVipp",
    slug: "ivipp",
    description: "Lifestyle Management & VIP Service",
    type: 2,
    tags: ["CRM", "AI"],
    images: [iv1, iv2],
    details: {
      overview:
        "iVipp is a premier lifestyle management platform that provides bespoke concierge services across the globe. Members gain exclusive access to luxury experiences, five-star travel accommodations, VIP events, and personalized services, ensuring a seamless and sophisticated lifestyle.",
      features: [
        "Global Concierge Services",
        "VIP Access to Exclusive Events",
        "Luxury Travel & Five-Star Accommodations",
        "Personalized Lifestyle Management",
        "Event Management & Corporate Services",
        "Private Transportation & Chauffeur Services",
        "Meal Prep & Personal Chef Services",
        "Dry Cleaning & Errand Management",
      ],
      industry: "Luxury & Lifestyle Management",
      tech_stack: ["React", "Node.js", "Stripe API", "Cloud-based CRM"],
      problem_solved:
        "Simplifies luxury lifestyle management by providing a single platform for VIP access, travel, events, and personal services.",
      key_metrics: [
        { title: "Active Members", detail: "10K+ VIP clients worldwide" },
        {
          title: "Concierge Requests Fulfilled",
          detail: "500K+ luxury services delivered",
        },
        { title: "Global Reach", detail: "Available in 50+ countries" },
      ],
      link: "https://ivipp.com/",
    },
  },
  {
    id: 11,
    name: "Lokotech",
    slug: "lokotech",
    description: "Pioneering Crypto Mining Hardware & Solutions",
    type: 1,
    tags: ["Crypto", "Blockchain", "Design"],
    images: [loko, loko, loko],
    details: {
      overview:
        "Lokotech is a leading innovator in cryptocurrency mining hardware, specializing in high-performance ASIC miners, energy-efficient solutions, and cutting-edge blockchain technology. With a focus on sustainability and efficiency, Lokotech provides miners with powerful and reliable hardware to maximize profitability.",
      features: [
        "High-Efficiency ASIC Miners",
        "Custom Mining Hardware Development",
        "Optimized Power Consumption & Cooling Systems",
        "Enterprise-Grade Mining Rigs",
        "Plug-and-Play Mining Solutions",
        "Advanced Hashing Algorithms",
        "Robust Security & Firmware Protection",
        "Remote Monitoring & Management Tools",
      ],
      industry: "Cryptocurrency Mining & Blockchain Technology",
      tech_stack: [
        "FPGA",
        "ASIC",
        "Rust",
        "GoLang",
        "Embedded Systems",
        "AI-Powered Optimization",
      ],
      problem_solved:
        "Lokotech enhances mining profitability with energy-efficient, high-performance hardware, reducing operational costs and improving mining sustainability.",
      key_metrics: [
        { title: "Hash Rate Delivered", detail: "500+ PH/s across miners" },
        {
          title: "Energy Efficiency",
          detail: "30% more efficient than competitors",
        },
        { title: "Global Adoption", detail: "Used by miners in 40+ countries" },
      ],
      link: "https://lokotech.com/",
    },
  },
];
